"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
async function sleepMilli(milli) {
    await new Promise(resolve => setTimeout(() => resolve(), milli));
}
exports.default = sleepMilli;
